import React, {Component} from "react";  import config from 'react-global-configuration';
import MdataMerchantV2 from 'components/Invoice/MdataMerchantV2';

class MasterDataV2 extends Component{

    componentDidMount() {

    }

    render() {
        return(
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Master Data V2</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="content">
                                    <MdataMerchantV2/>
                                </div>
                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MasterDataV2